import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import TeamSection from "../../components/TeamSection";
import CounterSection from "../../components/CounterSection";
import TestimonialsSection from "../../components/TestimonialsSection";
import ProcessSection from "../../components/ProcessSection";
import CtaSection from "../../components/CtaSection";

function About() {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="About Us" path="About Us" />

      <main className="about-page">
        {/* ABOUT SECTION */}
        <section className="about-area py-120">
          <div className="container">
            <div className="row align-items-center">
              {/* LEFT SIDE – IMAGES */}
             
<div className="col-lg-6">
  <div className="about-left position-relative">
    <div className="about-img">
      <div className="row g-0">
        
        {/* Image 1 */}
        <div className="col-6">
          <img
            src="/assets/images/img7.png"
            alt="Indian learners"
            className="img-fluid"
          />
        </div>

        {/* Image 2 */}
        <div className="col-6">
          <img
            src="/assets/images/02.jpg"
            alt="Indian classroom"
            className="img-fluid"
          />
        </div>

        {/* Image 3 */}
        <div className="col-6">
          <img
            src="/assets/images/12.png"
            alt="Indian tech students"
            className="img-fluid"
          />
        </div>

        {/* Image 4 */}
        <div className="col-6">
          <img
            src="/assets/images/24.jpg"
            alt="Online learning India"
            className="img-fluid"
          />
        </div>

      </div>
    </div>

    {/* EXPERIENCE BADGE */}
    <div className="about-experience">
      <h5>
        10<span>k+</span>
      </h5>
      <p>Students Trained</p>
    </div>
  </div>
</div>

              {/* RIGHT SIDE – CONTENT */}
              <div className="col-lg-6">
                <div className="about-right">
                  <span className="site-title-tagline">About Us</span>

                  <h2 className="site-title mt-2 hero-title">
                    The kademy — <span className="text-gradient">Practical tech education</span> for career outcomes
                  </h2>

                  <p className="about-text mt-3">
                    Welcome to The kademy. At The kademy, we believe that
                    potential is everywhere — but opportunity is not. Our
                    purpose is to close that gap.
                  </p>

                  <p className="about-text mt-3">
                    We exist to empower learners with the skills, confidence,
                    and real-world exposure required to succeed in today’s
                    competitive technology landscape. Our goal is not just
                    education, but career transformation — turning ambition
                    into ability and knowledge into employability.
                  </p>

                  <h6 className="mt-4">What We Do</h6>
                  <p className="about-text">
                    We design and deliver industry-aligned technical programs
                    that prepare learners for real jobs, not just exams. Our
                    training focuses on deep understanding of fundamentals,
                    hands-on project-driven learning, practical problem-solving,
                    and career readiness including interview preparation and
                    professional skills. Every course is continuously updated
                    to reflect current tools and hiring requirements.
                  </p>

                  <h6 className="mt-3">Who We Serve</h6>
                  <p className="about-text">
                    Thekademy is built for learners at every stage: students,
                    fresh graduates, job seekers looking to upskill or
                    transition, and self-driven learners seeking practical,
                    hands-on expertise. Regardless of your starting point, we
                    provide a structured path to help you progress with clarity
                    and confidence.
                  </p>

                  <h6 className="mt-3">Our Learning Philosophy</h6>
                  <p className="about-text">
                    Learning by Building — real projects, live coding, and
                    industry-style assignments; structured growth paths from
                    beginner to advanced; curriculum mapped to real job roles;
                    and expert mentorship from experienced professionals. We
                    focus on capability, confidence, and career outcomes — not
                    just certificates.
                  </p>

                  <h6 className="mt-3">Vision &amp; Mission</h6>
                  <p className="about-text">
                    <strong>Vision:</strong> To build a trusted, scalable
                    learning ecosystem that empowers thousands to achieve
                    sustainable careers in technology.
                  </p>
                  <p className="about-text">
                    <strong>Mission:</strong> To make high-quality, practical,
                    and career-oriented technical education accessible and
                    affordable — enabling learners to become skilled, confident,
                    and job-ready software professionals.
                  </p>

                  <h6 className="mt-3">
                    <span className="text-gradient">Join The kademy</span>
                  </h6>
                  <p className="about-text">
                            Your journey into the tech industry begins here.
                            Whether you’re starting from scratch or preparing for your next
                            career milestone, Thekademy is committed to supporting you
                            every step of the way.Learn with purpose. Build with confidence.
                            Grow with clarity. Get hired with skill.
                          </p>

                  <a href="/contact" className="theme-btn mt-4">
                    Contact Us →
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <CounterSection />

        <TeamSection />
        <TestimonialsSection />
        <ProcessSection />
        <CtaSection />
      </main>
    </>
  );
}

export default About;
